import React, { useState, useEffect } from "react";
// axios
import EnhancedAxios from "../../api/EnhancedAxios";
// mui
import { Autocomplete, TextField } from "@mui/material";
// icons
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useSelector } from "react-redux";
import { usePageParams } from "../../hooks/usePageParams";
import { getUserRole } from "../../utils/roles/getUserRole";

const DriverSelect = ({ setFilterValues }) => {
    const { page, setPage } = usePageParams();
    const userToken = useSelector((state) => state.userToken);
    const userData = useSelector((state) => state.userData);
    const [drivers, setDrivers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(null);
    const role = getUserRole(userData);
    // --------------------------------------- handle_autocomplete_changing ------------------------
    const handleAutocompleteChange = (e, newValue) => {
        setFilterValues((prev) => ({
            ...prev,
            driver_id: newValue ? `driver_id:${newValue.id}` : "",
        }));
        setValue(newValue ?? null);
        setPage("1");
    };
    // --------------------------------------- get_all_cities ------------------------
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/${role}/users?filters=roles:4&paginate=999999`)
            .then((response) => {
                setDrivers(response.data.data);
                setLoading(false);
            });
    }, []);
    // --------------------------------------- page_components ------------------------
    return (
        <Autocomplete
            sx={{ flex: "1", minWidth: "230px" }}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            options={drivers}
            loading={loading}
            onChange={handleAutocompleteChange}
            value={value ?? null}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="السائق المطلوب"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <AiOutlineLoading3Quarters /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
};

export default DriverSelect;
